import AOS from 'aos';
import { initSliders } from '../sliders';
export default {
  init() {
    // JavaScript to be fired on all pages
    AOS.init();
    initSliders();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js